export const MESSAGE_FEEDBACK = {
	COMMON: {
		ACCEPT_TERM_REQUIRED:
			'Bạn phải chấp nhận điều khoản và quy định đăng bài',
		CREATE_SUCCESS: 'Tạo mới thành công',
		UPDATE_SUCCESS: 'Cập nhật thành công',
		DELETE_SUCCESS: 'Xóa thành công',
		HIDE_SUCCESS: 'Ẩn thành công',
		SHOW_SUCCESS: 'Hiển thị thành công',
		CREATE_FAIL: 'Tạo mới thất bại',
		UPDATE_FAIL: 'Cập nhật thất bại',
		DELETE_FAIL: 'Xóa thất bại',
		HIDE_FAIL: 'Ẩn thất bại',
		SHOW_SUCCESS_FAIL: 'Hiển thị thất bại',
		ERROR_DES: 'Có vẻ như đã xảy ra lỗi. Hãy thử lại nhé',
		BLOCK_ACTION: 'Vui lòng chờ đợi trong giây lát',
		MOBILE_NOT_VALID: 'Số điện thoại không đúng định dạng hợp lệ',
		EMAIL_NOT_VALID: 'Email không đúng định dạng hợp lệ',
		BUTTON_OK: 'Có',
		BUTTON_CANCEL: 'Hủy bỏ',
		DELETE_WARNING:
			'Thao tác này sẽ không được hoàn tác. Bạn có chắc muốn xóa không?',
		HIDE_WARNING: 'Bạn có chắc muốn ẩn không?',
		DUPLICATE: 'Đã tồn tại giá trị này',
		WARNING_ACTION: 'Bạn có chắc chắn thực hiện thao tác không',
		PIN_SUCCESS: 'Ghim thành công',
		UNPIN_SUCCESS: 'Gỡ ghim thành công',
	},
	USER: {
		MSSV_REQUIRED: 'Mã nhân viên không được để trống',
		MSSV_DUPLICATED: 'Mã nhân viên đã tồn tại',
		PASSWORD_REQUIRED: 'Mật khẩu không được để trống',
		NAME_REQUIRED: 'Tên nhân viên không được để trống',
		EMAIL_REQUIRED: 'Email không được để trống',
		GENDER_REQUIRED: 'Giới tính không được để trống',
		DEPARTMENT_REQUIRED: 'Phòng ban làm việc không được để trống',
		SECTION_REQUIRED: 'Bộ phận làm việc không được để trống',
		UNIT_REQUIRED: 'Đơn vị làm việc không được để trống',
		POSITION_REQUIRED: 'Vị trí làm việc không được để trống',
		IMPORT_SUCCESS: 'Import thành công',
		IMPORT_FAIL: 'Import thất bại',
		OLD_PASSWORD_REQUIRED: 'Mật khẩu cũ không được để trống',
		NEW_PASSWORD_REQUIRED: 'Mật khẩu mới không được để trống',
		CONFIRM_PASSWORD_REQUIRED: 'Xác thực mật khẩu không được để trống',
		OLD_PASSWORD_WRONG: 'Mật khẩu cũ không chính xác',
		HIDE_USER_TITLE: 'Tạm ngưng tài khoản',
		HIDE_USER_DESCRIPTION:
			'Bạn có muốn tạm ngưng hoạt động của tài khoản này này?',
		PASSWORD_LENGTH: 'Mật khẩu phải dài hơn 6 kí tự',
	},
	TOPIC: {
		NAME_REQUIRED: 'Tiêu đề không được bỏ trống',
		DESCRIPTION_REQUIRED: 'Mô tả không được bỏ trống',
		BANNER_REQUIRED: 'Ảnh chủ đề không được bỏ trống',
	},
	AUTH: {
		USERNAME_PASSWORD_INVALID: 'Mã nhân viên hoặc mật khẩu không đúng',
	},
	POST: {
		LANG_REQUIRED: 'Ngôn ngữ không được bỏ trống',
		TITLE_REQUIRED: 'Tiêu đề không được bỏ trống',
		DESCRIPTION_REQUIRED: 'Mô tả không được bỏ trống',
		TOPIC_REQUIRED: 'Chủ đề không được bỏ trống',
		CATEGORY_REQUIRED: 'Loại chủ đề không được bỏ trống',
		BANNER_REQUIRED: 'Ảnh đại diện không được bỏ trống',
		TYPE_REQUIRED: 'Loại bài viết không được bỏ trống',
		VIDEO_ID_REQUIRED: 'Youtube ID không được bỏ trống',
		TEST_TYPE_REQUIRED: 'Loại kiểm tra không được bỏ trống',
		TEST_LINK_REQUIRED: 'Link test không được bỏ trống',
	},
	CATEGORY: {
		TOPIC_REQUIRED: 'Chủ đề không được bỏ trống',
	},
	HOMEPAGE: {
		INTRODUCE_REQUIRED: 'Giới thiệu không được bỏ trống',
		BIG_BANNER_REQUIRED: 'Hình ảnh trái không được bỏ trống',
		SMALL_BANNER_REQUIRED: 'Hình ảnh phải không được bỏ trống',
		SLIDE_IMAGE_REQUIRED: 'Ảnh nền không được bỏ trống',
	},
};
